import { Color, Spacing } from '@persona-id/design-tokens';
import { BORDER_RADIUSES } from 'shared/styles/variables';
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  .ProseMirror ul, .ProseMirror ol {
    padding-left: 30px;
  }
  .mention {
    background-color: ${Color.CorePurple100};
    color: ${Color.CorePurple700};
    border-radius: ${BORDER_RADIUSES.rounded};
    display: inline-flex;
    padding: 2px;
    align-items: center;
    gap: ${Spacing[1]};
  }
`;
